/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import DeviceModel, { PushSubscription } from 'cio/models/device';

interface PushStatusArgs {
  device: DeviceModel;
}

export default class PushStatus extends Component<PushStatusArgs> {
  get shouldDisplayPushStatus() {
    return this.isPushSubscriptionSet || this.hasDeliveryFailure;
  }

  get hasDeliveryFailure() {
    return this.args.device.isInDeliveryFailure;
  }

  get isPushSubscriptionSet() {
    return this.args.device.pushSubscription !== PushSubscription.Unset;
  }

  get isPushEnabled() {
    return this.args.device.pushSubscription === PushSubscription.Enabled;
  }
}
